import React from 'react';
import Page from 'components/page/Page';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Tbd() {
  return (
    <Page
      header='Du har ikke tilgang til "Adgang"'
      title='Ingen rettigheter'
    >
      <Row>
        <Col sm={12} lg={8}>
          <p>
            Du er logget inn, men har ikke nødvendige rettigheter for å bruke denne applikasjonen.
          </p>
          <h3>Hva er "Adgang"?</h3>
          <p>
            Adgang er administrasjonsverktøyet til MinSide for håndtering av brukere, roller og tilgangsstyring. Løsningen er kun tilgjengelig for personer med tildelt ansvar, for eksempel applikasjonsansvarlige eller systemforvaltere.
          </p>
          <h3>Hva kan du gjøre nå?</h3>
          <ul>
            <li>Trenger du tilgang som en del av jobben din? Kontakt applikasjonsansvarlig eller produkteier for løsningen du jobber med.</li>
            <li>Er du usikker på hvem det er? Ta kontakt med din nærmeste leder eller sjekk IT-produktoversikten.</li>
          </ul>
        </Col>
      </Row>
    </Page>
  );
}

export default Tbd;
